import type { ResourceType } from 'types/common';

export const filterIncludedItem = <TData extends { type: string }>(
  includedItems: any[] | undefined,
  recourseType: ResourceType
) => {
  if (!includedItems) {
    return;
  }

  return includedItems.filter(
    (includedItem) => includedItem.type === recourseType
  ) as TData[];
};
export function generateMap<T extends Record<string, any>>(
  data: T[] | undefined,
  mappingKey: string
): Record<string, T> | undefined {
  return data?.reduce<Record<string, T>>((acc, curr) => {
    const nestedPropertyValue = getNestedPropertyValue(curr, mappingKey);

    if (nestedPropertyValue !== undefined) {
      return {
        ...acc,
        [nestedPropertyValue]: curr,
      };
    }

    return acc;
  }, {});
}

function getNestedPropertyValue(
  dataObject: Record<string, any>,
  keyPath: string
): any {
  return keyPath
    .split('.')
    .reduce((acc, key) => (acc ? acc[key] : undefined), dataObject);
}
